import { IRAAutoMaxCalculationData, IRAAutoMaxCalculationState } from '.';
import { IRAAutoMaxCalculationActionTypes as act } from './actionTypes';
import { createApiPostActionCreator } from 'src/redux/utils/createApiPostActionCreator';

export const defaultIRAAutoMaxCalculationData: IRAAutoMaxCalculationData = {
  contributions: [],
  maxContributionLimit: Infinity,
  uniqueKey: '',
  consumerName: '',
};

export const defaultState: IRAAutoMaxCalculationState = {
  // Window API Fetch
  isLoading: false,
  loading: false,
  validationFailed: false,
  isLoaded: false,
  hasFailed: false,
  error: null,
  data: defaultIRAAutoMaxCalculationData,
};

export default function iraAutoMaxCartDetails(
  state: IRAAutoMaxCalculationState = defaultState,
  { payload, type }
): IRAAutoMaxCalculationState {
  switch (type) {
    case act.IRA_AUTO_MAX_CALCULATION_PENDING:
      return {
        ...state,
        isLoaded: false,
        isLoading: true,
      };
    case act.IRA_AUTO_MAX_CALCULATION_FULFILLED:
      const { body } = payload;
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        data: body,
      };

    case act.IRA_AUTO_MAX_CALCULATION_REJECTED:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        hasFailed: true,
        error: payload,
      };

    default:
      return state;
  }
}

export function getCalculation(payload) {
  return createApiPostActionCreator(
    act.IRA_AUTO_MAX_CALCULATION,
    'iraAutoMaxCalculation',
    payload
  );
}
